export const en = {
  app: {
    name: 'mycount',
    tagline: 'Wait, let me check something',
    install: 'Install app',
    downloading: 'Downloading',
    installing: 'Installing',
    downloadComplete: 'Installation complete',
    downloadRetrying: 'Connection lost, retrying...',
    downloadFailed: 'Download failed. Please try again later.',
    offlineReady: 'App ready for offline use',
    cacheCleared: 'Cache cleared, refreshing data...',
    updateReady: 'Update ready to install',
    updateInstalling: 'Installing update...',
    updateError: 'Update error',
    offlineMessage: 'You need to be online to use this application'
  },
  auth: {
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot password?',
      submit: 'Login',
      googleButton: 'Continue with Google',
      noAccount: "Don't have an account?",
      signupLink: 'Sign up',
      invalidCredentials: "Incorrect email or password",
      googleError: "Error signing in with Google. Please try again."
    },
    signup: {
      title: 'Sign up',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      terms: 'I have read and agree to the Terms of Service',
      privacyPolicy: "Privacy Policy",
      submit: 'Sign up',
      googleButton: 'Continue with Google',
      hasAccount: 'Already have an account?',
      loginLink: 'Login',
      signupError: "Error during sign up. This email may already be in use.",
      googleError: "Error signing up with Google. Please try again.",
      emailVerification: {
        title: "Verify your email",
        message: "A confirmation email has been sent to {{email}}. Please click the link in the email to complete your registration.",
        resend: "Resend email",
        resendSuccess: "Confirmation email resent!",
        resendError: "Error sending email. Please try again."
      }
    },
    forgotPassword: {
      title: 'Forgot password',
      email: 'Email',
      submit: 'Reset password',
      backToLogin: 'Back to login',
      instructions: 'Enter your email address to receive a reset link.',
      resetLinkError: 'Error sending reset link. Please try again.',
      emailSentTitle: 'Email Sent!',
      emailSentMessage: 'Check your inbox and follow the instructions to reset your password.'
    },
    validation: {
      emailRequired: 'Email is required',
      emailInvalid: 'Email is invalid',
      passwordRequired: 'Password is required',
      passwordTooShort: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      termsRequired: 'You must accept the terms of service'
    },
    resetPassword: {
      title: 'Reset Password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      submit: 'Reset',
      error: 'An error occurred while resetting your password',
      success: 'Your password has been reset successfully'
    }
  },
  home: {
    title: 'Couple Search',
    subtitle: 'Stay informed continuously, love with peace of mind',
    uploadPhoto: {
      title: "Let's add the photo here",
      subtitle: 'Face must be clearly visible',
      change: 'Click to change photo'
    },
    additionalInfo: {
      title: '',
      fullName: 'Full name',
      phone: 'Phone',
      country: 'Country',
      city: 'City',
      addNumber: 'Add a number'
    },
    search: 'Search',
    searching: 'Searching...',
    searchNote: 'Note: {error}. Text search will still be performed.',
    noResults: 'No results found for your search',
    singleSearch: 'Single Search',
    crawlText: {
      part1: 'Add your relationships',
      part2: '',
      part3: ' to your profile and ',
      part4: 'check weekly',
      part5: 'someone else is dating your partner',
      part6: ' on this page to see if ',
      part7: ', meaning if someone else has also added them to their profile'
    },
    results: {
      title: 'Results',
      certified: 'Certified relationship',
      pending: 'Awaiting certification',
      createdBy: 'Relationship created or certified by',
      createdOrCertifiedBy: 'Relationship created by/Relationship certified by',
      contact: 'Contact',
      match: 'match',
      unlockMessage: 'Unlock, see details',
      unlockDetailedMessage: 'Unlocka and see who this person is dating or married to',
      unlockTitle: 'Unlock!',
      unlockDescription: 'See who this person is dating or married to',
      count: '{{count}} results found',
      viewAll: 'View all',
      allResults: 'All results ({{count}})',
      viewDetails: 'View details'
    },
    login: {
      message: 'Login and see the results and find out who this person is dating or married to',
      required: 'Login Required'
    },
    addRelationPrompt: 'Add your relationships to your profile and receive alerts!',
    loginFullPrompt: 'Add your relationships to your profile and receive alerts!',
    unlock: {
      confirmTitle: 'Unlock Details',
      confirmMessage: 'Are you sure you want to find out who this person is in a relationship with or married to?',
      cost: 'Cost: {{price}}',
      donation: 'Cost: {{price}}',
      action: 'Unlock',
      waitingDonation: 'Waiting for payment...',
      remainingTime: 'Time remaining: {{minutes}}:{{seconds}}',
      thankYou: 'Thank you!'
    },
    infoPopup: {
      message: "Check if your relationship that you added to your profile is dating someone else, enter their information here",
      close: "Close"
    }
  },
  profile: {
    back: 'Back',
    homepage: 'Home page',
    myNumber: 'My number',
    description: 'You can put a link here',
    addRelationPopup: {
      message: "Are you in a relationship? Add your relations and secure them",
      close: "Close"
    },
    backButtonPopup: {
      message: "Perfect! Check if your relation is in a relationship with someone else, on the home page",
      close: "Close"
    },
    notifications: {
      title: 'Notifications',
      markAllAsRead: 'Mark all as read',
      deleteAll: 'Delete all',
      empty: 'No notifications',
      timeFormat: {
        days: 'd',
        hours: 'h',
        minutes: 'm',
        now: 'now'
      },
      messages: {
        relationSearched: 'A user searched for "{{name}}" and found it in their results.',
        relationConfirmed: '{{name}} has certified your relationship.',
        relationRejected: '{{name}} has rejected your relationship.',
        relationDeleted: '{{name}} has deleted your relationship.'
      },
      titles: {
        relationSearched: 'Your relationship was searched',
        relationConfirmed: 'Relationship certified',
        relationRejected: 'Relationship rejected',
        relationDeleted: 'Relationship deleted'
      }
    },
    relations: {
      title: 'My relations',
      add: 'Add',
      certifiedBy: 'Certified by {{name}}',
      unknown: 'Unknown name',
      status: {
        couple: 'couple',
        en_couple: 'In a relationship',
        married: 'married',
        ex: 'ex',
        date: 'dating'
      },
      confirmation: {
        pending: 'Certification',
        confirmed: 'Relation certified',
        rejected: 'Relation rejected'
      },
      share: 'Share',
      copied: 'Copied',
      shareHint: 'Share this relationship for certification',
      deleteConfirm: {
        certified: "Are you sure you want to delete this relationship? This action will also delete the relationship for the other user.",
        uncertified: "Are you sure you want to delete this relationship?"
      },
      deleteError: "Error deleting relationship",
      deleteFailed: "Deletion failed. Please try again.",
      deleteImpossible: "Unable to delete relationship. Please try again.",
      copyLink: 'Copy share link',
      mirror: 'Mirror',
      noName: 'No name',
      createdBy: 'Created by {{name}}'
    },
    addRelation: {
      title: 'New relation',
      editTitle: 'Edit relation',
      form: {
        photo: {
          add: 'Add a photo',
          change: 'Change photo',
          hint: 'Face must be clearly visible'
        },
        name: 'Full name',
        phone: 'Phone',
        addPhone: 'Add a number',
        country: 'Country',
        city: 'City',
        status: 'Status',
        submit: 'Add relation',
        update: 'Update relation',
        saving: 'Saving...',
        updating: 'Updating...',
        comment: 'Comment (optional)'
      }
    },
    userProfile: {
      defaultName: "User",
      defaultLink: "My Contact",
      defaultDescription: "Tell us about yourself in a few words",
      editName: {
        placeholder: "Enter your name"
      },
      editLink: {
        textPlaceholder: "Enter your description",
        urlPlaceholder: "Enter URL (optional)"
      },
      nameSaved: "Name saved!",
      linkSaved: "Link saved!",
      contactCopied: "Contact copied!"
    },
    shareRelation: {
      title: 'Preview',
      copyLink: 'Copy share link',
      copyPhone: 'Copy phone number'
    },
    help: {
      tips: 'Good to know',
      privacy: "Privacy Policy and Terms of Use",
      contact: 'Contact us',
      support: 'Support',
      tipsTitle: "Tips and tricks",
      contactTitle: "Need help?"
    },
    deleteRelation: {
      title: 'End the relationship',
      confirmation: 'Are you sure you want to end your relationship with {{name}}?',
      confirm: 'End it',
      cost: 'Deletion cost: {{price}}',
      donation: 'Deletion cost: {{price}}',
      waitingDonation: 'Waiting for payment...',
      thankYou: 'Thank you!',
      continueDonation: 'Complete payment'
    },
    datingProfile: {
      title: '',
      country: 'Country',
      countryPlaceholder: 'Your country',
      city: 'City',
      cityPlaceholder: 'Your city',
      gender: 'Gender',
      genderOption: {
        select: 'Select',
        male: 'Male',
        female: 'Female',
        other: 'Other'
      },
      age: 'Age',
      agePlaceholder: 'Your age',
      relationType: 'Type of relationship you are looking for',
      relationTypes: {
        shortTerm: 'Short term',
        longTerm: 'Long term',
        short: 'Short',
        long: 'Long'
      },
      shortTermIntentions: 'Intentions (Short term)',
      longTermIntentions: 'Intentions (Long term)',
      moneyAmount: 'How much?',
      moneyPlaceholder: 'Amount',
      moneyFlow: {
        give: 'Give',
        receive: 'Receive'
      },
      hookup: 'Hookup',
      resto: 'Restaurant',
      drink: 'Have a drink',
      seeWhat: 'Let\'s see',
      other: 'Other',
      marriage: 'Marriage',
      children: 'Children',
      fidelity: 'Fidelity',
      polygamy: 'Polygamy',
      free: 'Free',
      photos: 'Photos (Maximum 4)',
      visibility: 'Visibility in searches',
      activateVisibility: 'Activate visibility',
      contactClicks: 'Clicks on your contact',
      contactClicksInfo: 'This button automatically turns OFF after 5 clicks on your contact link, and your profile will be automatically hidden from singles search results. You can manually reactivate it at any time by turning it ON and saving your preferences. The counter continues from the last number of clicks recorded.',
      orientation: {
        title: 'Sexual Orientation',
        hetero: 'Heterosexual',
        gay: 'Gay',
        lesbian: 'Lesbian',
        bi: 'Bisexual'
      }
    },
    referral: {
      code: 'Referral code',
      codePlaceholder: 'Enter referral code',
      codeApplied: 'Referral code applied successfully',
      codeInfo: 'Enter a referral code if you have one'
    }
  },
  settings: {
    title: 'Settings',
    unsavedChangesTitle: 'Unsaved Changes',
    unsavedChangesMessage: 'You have unsaved changes. If you leave this page, all your changes will be lost.',
    stayOnPage: 'Stay on this page',
    leaveAnyway: 'Leave anyway',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave without saving?',
    saveSuccess: 'Preferences saved ✓',
    saveChanges: 'Save changes',
    save: 'Save my preferences',
    saving: 'Saving...',
    crawlText: 'Complete your profile to be visible in the singles searches.',
    photo: {
      title: 'Profile Photo',
      description: 'Upload a photo of yourself that clearly shows your face'
    },
    name: {
      title: 'Username',
      description: 'This is how other users will see you'
    },
    description: {
      title: "Description",
      placeholder: "Tell us about yourself in a few words (500 characters max)",
      charCount: "{{current}}/500 characters"
    },
    link: {
      title: 'Contact link or phone',
      description: 'Add a link to your social media or contact information',
      placeholder: 'No link added',
      hint: 'Enter a phone number or web link (URL). Accepted formats: +123456789 or https://...'
    },
    password: {
      title: 'Change password?',
      description: 'Change your password to secure your account',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      success: 'Your password has been changed successfully',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      error: {
        mismatch: 'Passwords do not match',
        tooShort: 'Password must be at least 6 characters long',
        updateFailed: 'Password update failed',
        currentPasswordIncorrect: 'Current password is incorrect',
        userNotFound: 'User not found'
      }
    },
    datingProfile: {
      title: ''
    },
    changePhoto: 'Change photo',
    customLink: 'Custom link name',
    customLinkPlaceholder: 'my-link',
    customLinkUrl: 'Link URL',
    logout: 'Logout',
    deleteAccount: 'Delete account',
    privacyPolicyButton: 'Privacy Policy and Terms of Service'
  },
  share: {
    title: 'says they are {{status}} with you',
    question: 'Do you certify this relationship?',
    confirm: 'I certify!',
    reject: 'I refuse!',
    backToHome: 'Back to home',
    creatorMessage: "This is what the person will see. Copy the link and send it to certify your relationship.",
    linkCopied: 'Link copied!',
    copyLink: 'Copy link',
    loginMessage: 'Login to reject or certify this relationship.',
    relationCertified: 'Relationship certified!',
    relationRejected: 'Relationship rejected',
    redirecting: 'Redirecting to your profile...',
    creatorAlt: 'Relationship creator',
    targetAlt: 'Concerned person',
    auth: {
      signup: {
        title: 'Not registered?',
        button: 'Sign up',
        description: 'Sign up to MyCount to certify the relationship'
      },
      login: {
        title: 'Already registered?',
        button: 'Login',
        description: 'Login to MyCount to certify the relationship'
      }
    },
    errors: {
      relationNotFound: "Relation not found in database",
      loadingError: "An error occurred while loading the relation",
      certificationError: "An error occurred during certification",
      rejectionError: "An error occurred during rejection"
    },
    payment: {
      title: 'Unlock results',
      message: 'To view short-term results, a payment is required.'
    },
    loginPrompt: 'Log in to find singles in your city',
    crushLimitPopup: {
      title: 'Limit Reached',
      message: 'You can only add 3 crushes per search. To add more crushes, start a new search.',
      close: 'Close'
    },
    hide: 'Hide'
  },
  imageCropper: {
    title: "Crop image",
    subtitle: "Position the frame so that the face is clearly visible",
    cancel: "Cancel",
    validate: "Validate",
    preview: "Preview"
  },
  notifications: {
    new_relation: {
      title: "New relationship",
      message: "{{userName}} created a new relationship with {{targetName}}."
    },
    relation_confirmed: {
      title: "Relationship confirmed",
      message: "{{targetName}} confirmed your relationship."
    },
    relationConfirmed: {
      title: "Relationship certified",
      message: "{{name}} has certified your relationship."
    },
    relationRejected: {
      title: "Relationship rejected",
      message: "{{targetName}} rejected your relationship."
    },
    relationDeleted: {
      title: "Relationship deleted",
      message: "{{targetName}} deleted your relationship."
    },
    search_result: {
      title: "Search result",
      message: "We found {{count}} match(es) for your search."
    },
    search_found: {
      title: "Your relationship was found",
      message: "A user searched for {{targetName}} and found them in their results."
    },
    relationSearchedByUser: {
      title: "Your relationship was searched",
      message: "{{user}} searched for \"{{name}}\" and found it in their results."
    },
    relationSearched: {
      title: "Your relationship was searched",
      message: "A user searched for \"{{name}}\" and found it in their results."
    },
    relationDeletedByCreator: {
      title: 'Relationship deleted',
      message: '{{user}} has deleted the relationship with {{name}}.'
    },
    relationDeletedByCertified: {
      title: 'Relationship deleted',
      message: '{{user}} has deleted the relationship with {{name}}.'
    }
  },
  payment: {
    back: 'Back',
    deleteTitle: 'Payment for Deletion',
    unlockTitle: 'Payment for Unlocking',
    pay: 'Pay Now',
    processing: 'Processing...',
    success: 'Payment Successful!',
    finalizing: 'Finalizing your request...',
    secureInfo: 'Your payment information is secure and encrypted.',
    fillAllFields: 'Please fill in all fields',
    failed: 'Payment failed',
    genericError: 'An error occurred during payment. Please try again.',
    
    // Mobile Money
    mobileNumber: 'Mobile Phone Number',
    mobileNumberHint: 'Enter the number associated with your Mobile Money account',
    initiate: 'Initiate Payment',
    mobileMoneyInitiated: 'Payment request initiated',
    waitingForPayment: 'Waiting for your payment',
    checkYourPhone: 'Please check your phone to confirm the payment',
    followInstructions: 'Follow the instructions on your phone to complete the payment',
    cancel: 'Cancel Payment',
    
    services: {
      shortTermUnlock: 'Unlock short-term encounters',
      relationDeletion: 'Delete relationship',
      searchDetailsUnlock: 'Unlock search details'
    },
    
    mobile: {
      fullName: 'Full Name',
      phoneNumber: 'Phone Number',
      phoneFormat: 'Format: +237XXXXXXXXX',
      instructions: 'Payment Instructions',
      checkPhone: 'Check your phone to validate the payment',
      waitingMobile: 'Waiting for your confirmation on the phone...',
      zones: {
        xaf: 'FCFA Zone (Central Africa)',
        xof: 'FCFA Zone (West Africa)',
        cdf: 'Congolese Franc (DRC)'
      },
      providers: {
        orange_cm: 'Orange Cameroon',
        mtn_cm: 'MTN Cameroon',
        orange_ga: 'Orange Gabon',
        airtel_ga: 'Airtel Gabon',
        orange_cg: 'Orange Congo',
        mtn_cg: 'MTN Congo',
        orange_cf: 'Orange Central African Republic',
        orange_td: 'Orange Chad',
        orange_sn: 'Orange Senegal',
        free_sn: 'Free Senegal',
        wave_sn: 'Wave Senegal',
        moov_bj: 'Moov Benin',
        mtn_bj: 'MTN Benin',
        orange_ci: 'Orange Ivory Coast',
        mtn_ci: 'MTN Ivory Coast',
        moov_ci: 'Moov Ivory Coast',
        orange_ml: 'Orange Mali',
        moov_tg: 'Moov Togo',
        tmoney_tg: 'T-Money Togo',
        orange_cd: 'Orange DRC',
        airtel_cd: 'Airtel DRC',
        mpesa_cd: 'M-Pesa DRC'
      }
    },
    card: {
      cvvInfo: 'The CVV is the 3-digit code on the back of your card',
      nameInfo: 'The name must match exactly as written on your card'
    },
    
    // Payment Flow
    title: 'Simple Payment Workflow (Mobile Money)',
    stepOne: 'Choose the premium option',
    stepTwo: {
      title: 'Your profile',
      gender: 'Gender',
      birthDate: 'Birth date',
      birthDatePlaceholder: 'Select your birth date',
      sexuality: 'Sexual orientation',
      genderOptions: {
        man: 'Man',
        woman: 'Woman'
      },
      sexualityOptions: {
        hetero: 'Heterosexual',
        gay: 'Gay',
        lesbian: 'Lesbian',
        bisexual: 'Bisexual',
        bi: 'Bisexual'
      }
    },
    step3: {
      title: 'Relationship Type',
      relationType: 'What type of relationship are you looking for?',
      youSearch: 'You are looking for?',
      shortTerm: 'Short term',
      longTerm: 'Long term',
      shortTermIntentions: 'Intentions (Short term)',
      longTermIntentions: 'Intentions (Long term)',
      money: 'Budget (optional)',
      moneyPlaceholder: 'Enter an amount',
      moneyFlow: 'Who pays?',
      selectMoneyFlow: 'Select who pays',
      iReceive: 'I receive',
      iPay: 'I pay',
      intentions: 'Your intentions',
      hookup: 'Hookup',
      resto: 'Restaurant',
      drink: 'Drinks',
      seeWhat: 'Let\'s see',
      other: 'Other',
      marriage: 'Marriage',
      children: 'Children',
      fidelity: 'Fidelity',
      polygamy: 'Polygamy',
      free: 'Free'
    },
    step4: {
      title: 'Contact Information',
      phone: 'Phone',
      phonePlaceholder: 'Enter your phone number',
      contactLink: 'Contact Link',
      contactLinkPlaceholder: 'Enter your contact link (Instagram, Telegram, etc.)'
    },
    userClicks: 'The user clicks on a button:',
    userSees: 'They see the',
    amount: 'Amount',
    andThe: 'and the',
    paymentMethods: 'payment methods',
    available: 'available',
    activate: 'Activate',
    unlock: 'Unlock',
    payButton: 'Pay',
    continue: 'Continue',
    proceed: 'Proceed to payment',
    orangeMoney: 'Orange Money',
    mtnMoney: 'MTN Mobile Money',
    manualTransfer: 'Information for manual transfer',
    manualInstructions: 'Provide the following information for manual transfer:',
    example: 'Example:',
    sendAmount: 'Send',
    to: 'to',
    reference: 'Reference',
    manualTransferNote: 'After completing the transfer, <span class="text-yellow-400">copy the transaction ID you received</span>, paste it in the input field below, and click \'I have paid\' to confirm your payment.',
    verify: 'I have paid',
    processingPayment: 'Processing...'
  },
  common: {
    or: "or",
    cancel: "Cancel",
    customerService: "Customer service",
    profile: "Profile",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    delete: "Delete",
    deleting: "Deleting...",
    unexpectedError: "An unexpected error occurred",
    offlineMode: "Offline mode",
    offlineDataAvailable: "Offline data available",
    offlineFeature: "Not available offline",
    offlineSearchDisabled: "Search is not available in offline mode",
    later: "Later",
    login: "Login",
    search: "Search",
    seeMore: "See more",
    seeLess: "See less",
    back: 'Back',
    edit: 'Edit',
    settings: 'Settings',
    save: 'Save',
    saveAll: 'Save All',
    saving: 'Saving...',
    close: 'Close',
    confirm: 'Confirm',
    send: 'Send',
    add: 'Add',
    logout: 'Logout',
    comingSoon: 'Feature coming soon',
    refresh: "Refresh"
  },
  update: {
    newVersion: 'New version available',
    description: 'A new version of the app is available. Install it to get the latest features and fixes.',
    install: 'Install',
    installAndReload: 'Install and restart',
    downloading: 'Downloading update...',
    preparing: 'Preparing installation...',
    restarting: 'Restarting app...'
  },
  offline: {
    mode: 'Offline mode',
    ready: 'App ready for offline use',
    syncing: 'Syncing data...',
    syncComplete: 'Sync complete',
    syncError: 'Sync error',
    queuedActions: 'Pending actions',
    processingQueue: 'Processing pending actions...',
    dataAvailable: 'Data available offline',
    dataUnavailable: 'Data not available offline',
    featureUnavailable: 'This feature is not available offline',
    reconnecting: 'Attempting to reconnect...',
    reconnected: 'Connection restored',
    connectionLost: 'Connection lost'
  },
  singleSearch: {
    title: 'Single Search',
    subtitle: 'Find your next crush',
    crawlText: {
      part1: 'Register',
      part2: '',
      part3: ' your contact details in your ',
      part4: 'profile settings',
      part5: '',
      part6: ', to be found here.',
      part7: ''
    },
    photoCarousel: {
      title: '',
      loading: 'Loading photos...',
      error: 'Unable to load photos',
      emptyState: 'No photos available at the moment'
    },
    form: {
      country: 'Country',
      city: 'City',
      ageRange: 'Age range',
      gender: 'Gender',
      ageRanges: {
        '18-25': '18-25 years',
        '26-35': '26-35 years',
        '36-45': '36-45 years',
        '46-55': '46-55 years',
        '56+': '56+ years'
      },
      genderOptions: {
        homme: 'Male',
        femme: 'Female'
      },
      search: 'Search',
      searching: 'Searching...'
    },
    results: {
      searching: 'Searching...',
      found: '{{count}} result{{plural}} found',
      notFound: 'No results found',
      searchingMessage: 'Searching for singles...',
      tryModify: 'Try modifying your search criteria',
      longTerm: 'Long term',
      shortTerm: 'Short term',
      age: 'years',
      photos: 'photos',
      foundSimple: 'found'
    },
    gallery: {
      photo: 'Photo {{current}} of {{total}}',
      of: 'of',
      swipeToNavigate: 'Swipe to navigate'
    },
    intentions: {
      hookup: 'Hookup',
      resto: 'Restaurant',
      drink: 'Drinks',
      seeWhat: 'Let\'s see',
      other: 'Others',
      marriage: 'Marriage',
      children: 'Children',
      fidelity: 'Fidelity',
      polygamy: 'Polygamy',
      free: 'Free'
    },
    payment: {
      title: 'Unlock results',
      message: 'To view short-term results, a payment is required.'
    },
    loginPrompt: 'Log in to find singles in your city'
  },
  thankYou: 'Thank you for your contribution!',
  myCrush: {
    title: 'My Crush',
    subtitle: '',
    loading: 'Loading your crushes...',
    empty: {
      title: 'No crushes yet',
      message: 'Use the heart button on profiles you like to find them here.',
      action: 'Start searching'
    },
    count: {
      single: 'You have {{count}} crush',
      plural: 'You have {{count}} crushes'
    },
    relation: {
      shortTerm: 'Short term relationship',
      longTerm: 'Long term relationship'
    },
    deleteSuccess: 'Profile removed from crushes',
    deleteError: 'Error while deleting',
    expirationInfo: 'Crushes automatically expire after 7 days',
    expiresIn: 'Expires',
    refresh: 'Refresh',
    refreshSuccess: 'List refreshed'
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    termsTitle: 'Terms of Service',
    loading: 'Loading content...',
    errorLoading: 'Error loading content. Please try again later.'
  },
  admin: {
    accessDenied: {
      title: "Access Denied",
      message: "You don't have the necessary permissions to access this page.",
      returnHome: "Return to home"
    },
    dashboard: {
      title: "Admin Dashboard",
      roleLabel: "Role",
      returnToApp: "Return to app",
      statsTitle: "Statistics",
      sectionsTitle: "Sections",
      noStats: "No statistics available",
      noAccessibleSections: "No accessible sections",
      manageSection: "Manage",
      errorFetchingStats: "Error fetching statistics",
      returnToDashboard: "Return to dashboard",
      sections: {
        users: "Users",
        settings: "Settings"
      },
      stats: {
        users: "Users",
        relations: "Relations",
        payments: "Payments",
        activeUsers: "Active users",
        certifiedRelations: "Certified relations"
      },
      sectionDescriptions: {
        users: "Manage users and their permissions",
        relations: "Manage relations and certifications",
        payments: "Track transactions and payments",
        settings: "Configure application settings"
      }
    },
    header: {
      admin: "Admin",
      adminArea: "Admin Area",
      becomeAdmin: "Become an admin, get other users to register and earn money for life",
      contactUs: "Contact Us"
    },
    settings: {
      title: "Admin Settings",
      featurePricing: "Feature Pricing",
      relationDeletionPrice: "Price to delete a relation",
      relationUnlockPrice: "Price to unlock relation details",
      shortTermSearchUnlockPrice: "Price to unlock short-term relationship results in search",
      amount: "Amount",
      currency: "Currency",
      enabled: "Enabled",
      paymentGateway: "Payment Gateway",
      gateways: "Gateways",
      alternativeUrl: "Alternative URL",
      alternativeUrlDescription: "URL to redirect users for payment (use $bodycount as variable)",
      mobilePaymentNumbers: "Mobile Payment Numbers",
      orangeMoney: "Orange Money",
      mtnMoney: "MTN Money",
      add: "Add",
      noNumbersConfigured: "No numbers configured",
      number: "Number",
      reference: "Reference",
      helpButton: "Help Button",
      animation: "Animation",
      helpButtonDescription: "Enable/disable help button animation",
      helpResources: "Help Resources",
      tips: "Tips",
      contact: "Contact",
      don: "Donation",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      editResource: "Edit Resource",
      newResource: "New Resource",
      type: "Type",
      status: "Status",
      resourceTitle: "Title",
      link: "Link",
      description: "Description",
      enterDescription: "Enter a description",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      saveAll: "Save All",
      modified: "Modified on"
    }
  },
  signupFlow: {
    title: 'Complete your profile',
    subtitle: 'MyCount is a web app for meeting and managing relationships. Dating intentions are clear and contact is direct. No wasted time or unnecessary messaging.',
    stepSubtitles: {
      1: 'MyCount is a web app for meeting and managing relationships. Dating intentions are clear and contact is direct. No wasted time or unnecessary messaging.',
      2: 'Find Love or love, directly on MyCount',
      3: 'Dating intentions are clear and contact is direct. No wasted time or unnecessary messaging.',
      4: 'You will be contacted directly by this contact',
      5: 'MyCount addresses all those who want direct, concrete and real',
      6: 'A freedom and a new way to make contacts'
    },
    prevStep: 'Previous',
    nextStep: 'Next',
    finish: 'Finish',
    error: {
      savingProfile: 'An error occurred while saving your profile. Please try again.'
    },
    step1: {
      title: 'Basic Information',
      fullName: 'Username',
      fullNamePlaceholder: 'Enter your username',
      country: 'Country',
      countryPlaceholder: 'Select your country',
      city: 'City',
      cityPlaceholder: 'Enter your city',
      language: 'Language',
      languageOptions: {
        fr: 'French',
        en: 'English'
      }
    },
    step2: {
      title: 'Your Profile',
      subtitle: 'Find Love or love, directly on MyCount',
      gender: 'Gender',
      genderOptions: {
        man: 'Male',
        woman: 'Female'
      },
      birthDate: 'Date of birth',
      birthDatePlaceholder: 'Select your date of birth',
      sexuality: 'Sexual orientation',
      sexualityOptions: {
        hetero: 'Heterosexual',
        gay: 'Gay',
        lesbian: 'Lesbian',
        bisexual: 'Bisexual',
        bi: 'Bisexual'
      }
    },
    step3: {
      title: 'Relationship Type',
      relationType: 'What type of relationship are you looking for?',
      youSearch: 'You are looking for?',
      shortTerm: 'Short term',
      longTerm: 'Long term',
      shortTermIntentions: 'Short term intentions',
      longTermIntentions: 'Long term intentions',
      money: 'Budget (optional)',
      moneyPlaceholder: 'Enter an amount',
      moneyFlow: 'Who pays?',
      selectMoneyFlow: 'Select who pays',
      iReceive: 'I receive',
      iPay: 'I pay',
      intentions: 'Your intentions',
      hookup: 'Hookup',
      resto: 'Restaurant',
      drink: 'Drinks',
      seeWhat: 'Let\'s see',
      other: 'Other',
      marriage: 'Marriage',
      children: 'Children',
      fidelity: 'Fidelity',
      polygamy: 'Polygamy',
      free: 'Free'
    },
    step4: {
      title: 'Contact Information',
      phone: 'Phone',
      phonePlaceholder: 'Enter your phone number',
      contactLink: 'Contact link',
      contactLinkPlaceholder: 'Enter your contact link (Instagram, Telegram, etc.)'
    },
    step5: {
      title: 'Photos',
      description: 'Add at least 2 photos of you. The first photo will be your profile picture.',
      addPhoto: 'Add a photo'
    },
    step6: {
      title: 'Search Visibility'
    }
  }
};
